import { formIsValidSelector } from "@/pages/ContactsPage/slice";
import { useAppDispatch, useAppSelector } from "@/services/store";
import { blockingModalActions } from "./blocking-modal-slice";

export const useInvalidContactModal = () => {
  const dispatch = useAppDispatch();

  const formIsValid = useAppSelector(formIsValidSelector);

  const executeWithConfirm = (callback: () => void) => () => {
    if (!formIsValid) {
      dispatch(blockingModalActions.setConfirmIsVisible({ open: true, handleCancel: callback }));
      return;
    }

    callback();
  };

  return { executeWithConfirm };
};
